export enum CoinDetailsTabs {
  CHART = 'CHART',
  BALANCE = 'BALANCE',
  STATISTICS = 'STATISTICS',
  PRICE_DYNAMICS = 'PRICE_DYNAMICS',
}

export enum CoinDetailsCharts {
  PRICE_CHART = 'PRICE_CHART',
  MARKET_CAP = 'MARKET_CAP',
}

export type CoinDetailsTabItem = { title: string; id: CoinDetailsTabs };

export const COIN_DETAILS_SECTION_IDS = {
  CHART: 'chart',
  DYNAMICPRICE: 'dynamic-price',
  STATS: 'statistics',
  TRANSACTIONS: 'transactions',
};
